import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import GeneralRegistration from './GeneralRegistration';
import IndividualRegistration from './IndividualRegistration';
import DonationRegistration from './DonationRegistration';
import WhitelistRegistration from './WhitelistRegistration';
import TeamRegistration from './TeamRegistration';

interface RegistrationModalProps {
  show: boolean;
  onHide: () => void;
  event: any;
  category: any;
  user?: any;
  registrationType: 'general' | 'individual' | 'donation' | 'whitelist' | 'team';
}

const RegistrationModal: React.FC<RegistrationModalProps> = ({
  show,
  onHide,
  event,
  category,
  user,
  registrationType
}) => {
  const [success, setSuccess] = useState(false);

  const handleSuccess = (data: any) => {
    setSuccess(true);
    // Optionally close modal after a delay
    setTimeout(() => {
      onHide();
      setSuccess(false);
    }, 3000);
  };

  const handleCancel = () => {
    onHide();
    setSuccess(false);
  };

  const renderRegistrationComponent = () => {
    const commonProps = {
      event,
      category,
      user,
      onSuccess: handleSuccess,
      onCancel: handleCancel
    };

    switch (registrationType) {
      case 'general':
        return <GeneralRegistration {...commonProps} />;
      case 'individual':
        return <IndividualRegistration {...commonProps} />;
      case 'donation':
        return <DonationRegistration {...commonProps} />;
      case 'whitelist':
        return <WhitelistRegistration {...commonProps} />;
      case 'team':
        return <TeamRegistration {...commonProps} />;
      default:
        return <GeneralRegistration {...commonProps} />;
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleCancel}
      size="lg"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body className="p-0">
        {renderRegistrationComponent()}
      </Modal.Body>
    </Modal>
  );
};

export default RegistrationModal;
